exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".q-line[data-v-700a8723]{width:100%;border-bottom:1px dashed #1E89E4}\n", ""]);
